// src/plugins/vuetify.js

// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
// import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
// import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vue from 'vue'

// SENZA VUETIFY LOADER
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

// CON VUETIFY LOADER
import Vuetify from 'vuetify/lib'

// custom colors
import light from './light'
import dark from './dark'

// Translation provided by Vuetify (javascript)
import it from 'vuetify/lib/locale/it'

Vue.use(Vuetify)

const opts = {
	icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg',
    values: {
      // file: ''
    }
  },
	lang: {
    locales: { it },
    current: 'it',
  },
	theme: {
    dark: false,
    themes: {
      light,
      dark
    },
    options: {
      customProperties: true,
      // themeCache: {
      //   get: key => localStorage.getItem(key),
      //   set: (key, value) => localStorage.setItem(key, value),
      // },
    },
  },
}

export default new Vuetify(opts)
